/*
============================================================
VARIKAA AI — PRODUCT CONTROL PANEL
============================================================

IMPORTANT:
This file contains PRODUCT CONTENT only.

EDIT HERE:
- Product information
- Hero experience
- Questions
- Answer choices
- Recommendation signals
- Approved benefits
- Usage
- FAQs
- Result copy

DO NOT PUT:
- Shiprocket checkout code
- Shopify cart code
- Popup submission code
- General UI/engine logic

============================================================
*/


const VARIKAA_AI_PRODUCTS = {

  /*
  ==========================================================
  PRODUCT 01 — METAFIZZ+
  ==========================================================
  */

  metafizz_plus: {

    /*
    ----------------------------------------------------------
    BASIC PRODUCT INFORMATION
    ----------------------------------------------------------
    */

    id: "metafizz_plus",

    name: "MetaFizz+",

    handle: "metafizz-apple-cider-vinegar-moringa-effervescent-tablets-pomegranate-flavour",

    productUrl:
      "/products/metafizz-apple-cider-vinegar-moringa-effervescent-tablets-pomegranate-flavour",


    /*
    ----------------------------------------------------------
    HERO EXPERIENCE
    ----------------------------------------------------------
    */

    hero: {

      /*
      These will be replaced with the FINAL approved
      MetaFizz+ product/hero assets.

      Do not use a random product image here.
      We will connect the exact approved asset later.
      */

      heroImage: "https://cdn.shopify.com/s/files/1/0704/9186/5167/files/49F8CB33-BF60-4749-855C-7FDB6EB0A6BC.png?v=1788544916",

      splashImage: "https://cdn.shopify.com/s/files/1/0704/9186/5167/files/5AE500C7-EFAE-4C9A-A9FC-C3D5FC4DBFBC.png?v=1788608856",

      triggerAfterScrollPercent: 10,

      position: "right-center",

      entranceAnimation: "drop",

      invitationTitle:
        "Is MetaFizz+ Right for Your Routine?",

      invitationAction:
        "Let’s find out →"

    },


    /*
    ----------------------------------------------------------
    PRODUCT FORMULA
    ----------------------------------------------------------
    */

    formula: {

      appleCiderVinegar: {
        amount: "500 mg",
        displayName: "Apple Cider Vinegar"
      },

      moringa: {
        amount: "300 mg",
        displayName: "Moringa"
      },

      pomegranate: {
        amount: "100 mg",
        displayName: "Pomegranate"
      },

      vitaminB6: {
        amount: "0.95 mg",
        displayName: "Vitamin B6"
      },

      vitaminB12: {
        amount: "1 mcg",
        displayName: "Vitamin B12"
      }

    },


    /*
    ----------------------------------------------------------
    PRODUCT FORMAT
    ----------------------------------------------------------
    */

    format: {

      type: "Effervescent tablet",

      flavour: "Pomegranate",

      tabletsPerPack: 15

    },


    /*
    ----------------------------------------------------------
    APPROVED BENEFIT PILLARS
    ----------------------------------------------------------
    */

    benefits: {

      weightManagement: {
        title:
          "Support healthy weight management",

        ingredient:
          "Apple Cider Vinegar",

        text:
          "MetaFizz+ is formulated with 500 mg Apple Cider Vinegar to support your healthy weight-management routine."
      },


      cravings: {
        title:
          "Helps to manage cravings",

        ingredient:
          "Apple Cider Vinegar",

        text:
          "MetaFizz+ is formulated with Apple Cider Vinegar to help manage cravings as part of a balanced wellness routine."
      },


      energy: {
        title:
          "Daily energy support",

        ingredient:
          "Moringa + Vitamin B6 + Vitamin B12",

        text:
          "Moringa together with Vitamin B6 and B12 forms the energy-support side of the MetaFizz+ formula."
      },


      gutWellness: {
        title:
          "Gut wellness",

        ingredient:
          "Apple Cider Vinegar + Moringa",

        text:
          "The combination of Apple Cider Vinegar and Moringa supports MetaFizz+'s everyday gut-wellness positioning."
      }

    },


    /*
    ----------------------------------------------------------
    USAGE
    ----------------------------------------------------------
    */

    usage: {

      frequency:
        "One tablet per day",

      water:
        "200 ml",

      waterTemperature:
        "Cold water",

      preparation:
        "Drop one tablet into 200 ml of cold water and allow it to dissolve completely before drinking.",

      timing:
        "30 minutes before a meal",

      hotWaterWarning:
        "Do not use with hot water."

    },


    /*
    ----------------------------------------------------------
    QUESTIONS
    ----------------------------------------------------------
    */

    questions: [

      {
        id: "q1",

        number: 1,

        title:
          "What are you looking for from your daily wellness routine?",

        options: [

          {
            value: "weight",
            label: "Healthy weight management"
          },

          {
            value: "cravings",
            label: "Better control over cravings"
          },

          {
            value: "energy",
            label: "Daily energy support"
          },

          {
            value: "gut",
            label: "Gut wellness"
          },

          {
            value: "combination",
            label: "A combination of these"
          }

        ]

      },


      {
        id: "q2",

        number: 2,

        title:
          "What does a typical day look like for you?",

        options: [

          {
            value: "busy",
            label: "Busy & always on the go"
          },

          {
            value: "desk",
            label: "Mostly work / desk-based"
          },

          {
            value: "active",
            label: "Active & fitness-focused"
          },

          {
            value: "home",
            label: "Mostly home-based"
          },

          {
            value: "changing",
            label: "My routine changes day to day"
          }

        ]

      },


      {
        id: "q3",

        number: 3,

        title:
          "When choosing a wellness product, what matters most to you?",

        options: [

          {
            value: "ingredients",
            label: "Ingredients"
          },

          {
            value: "benefits",
            label: "Benefits"
          },

          {
            value: "taste",
            label: "Taste & experience"
          },

          {
            value: "convenience",
            label: "Convenience"
          },

          {
            value: "consistency",
            label: "Something I can actually stay consistent with"
          }

        ]

      },


      {
        id: "q4",

        number: 4,

        title:
          "What kind of wellness routine would you actually enjoy sticking to?",

        options: [

          {
            value: "simple",
            label: "Simple — I don’t want to overthink it"
          },

          {
            value: "morning",
            label: "Something I can build into my morning"
          },

          {
            value: "refreshing",
            label: "Something refreshing that feels enjoyable"
          },

          {
            value: "structured",
            label: "I like having a structured routine"
          },

          {
            value: "figuring_out",
            label: "I’m still figuring it out"
          }

        ]

      }

    ],


    /*
    ----------------------------------------------------------
    QUESTION SIGNAL PRIORITY
    ----------------------------------------------------------

    Q1 = Primary benefit signal
    Q2 = Routine compatibility
    Q3 = Buying motivation
    Q4 = Routine framing

    These are signals for the recommendation engine.
    They are NOT medical diagnosis.
    ----------------------------------------------------------
    */

    recommendationSignals: {

      primary: "q1",

      secondary: "q2",

      motivation: "q3",

      routinePreference: "q4"

    },


    /*
    ----------------------------------------------------------
    RESULT INTRODUCTION
    ----------------------------------------------------------
    */

    result: {

      title:
        "Here’s how MetaFizz+ may fit your routine.",

      defaultIntro:
        "MetaFizz+ combines Apple Cider Vinegar, Moringa, Pomegranate, Vitamin B6 and Vitamin B12 in a convenient effervescent format for a simple daily wellness routine."

    },


    /*
    ----------------------------------------------------------
    RESULT MAPPING
    ----------------------------------------------------------
    */

    resultMapping: {

      weight: {

        intro:
          "You're looking for healthy weight-management support. MetaFizz+ may fit that goal through its 500 mg Apple Cider Vinegar component.",

        focusTitle:
          "Healthy weight-management support",

        focusText:
          "MetaFizz+ is formulated with 500 mg Apple Cider Vinegar to support your healthy weight-management routine."

      },


      cravings: {

        intro:
          "You're looking for help managing cravings as part of your wellness routine. MetaFizz+ includes 500 mg Apple Cider Vinegar as part of that positioning.",

        focusTitle:
          "Craving management",

        focusText:
          "MetaFizz+ is formulated with Apple Cider Vinegar to help manage cravings as part of a balanced wellness routine."

      },


      energy: {

        intro:
          "You're looking for daily energy support. MetaFizz+ combines Moringa with Vitamins B6 and B12 as part of its daily energy-support positioning.",

        focusTitle:
          "Daily energy support",

        focusText:
          "Moringa together with Vitamin B6 and B12 forms the energy-support side of the MetaFizz+ formula."

      },


      gut: {

        intro:
          "You're looking for gut wellness support. MetaFizz+ combines Apple Cider Vinegar and Moringa as part of its everyday gut-wellness positioning.",

        focusTitle:
          "Gut wellness",

        focusText:
          "The combination of Apple Cider Vinegar and Moringa supports MetaFizz+'s everyday gut-wellness positioning."

      },


      combination: {

        intro:
          "You're looking for a combination of wellness benefits. MetaFizz+ brings ACV, Moringa, Pomegranate and Vitamins B6 and B12 together in one convenient effervescent routine.",

        focusTitle:
          "A broader daily wellness routine",

        focusText:
          "MetaFizz+ combines several ingredients and approved wellness-support positions in one convenient effervescent format."

      }

    },


    /*
    ----------------------------------------------------------
    ROUTINE RESULT MAPPING
    ----------------------------------------------------------
    */

    routineMapping: {

      busy: {

        title:
          "Simple preparation",

        text:
          "A one-tablet effervescent format can be incorporated into a busy or changing routine without measuring liquid ACV."

      },

      changing: {

        title:
          "Simple preparation",

        text:
          "A one-tablet effervescent format can be incorporated into a busy or changing routine without measuring liquid ACV."

      },

      active: {

        title:
          "Fits an active lifestyle",

        text:
          "MetaFizz+ is designed as a convenient daily wellness drink that can fit into an active routine."

      },

      desk: {

        title:
          "An easy daily ritual",

        text:
          "The simple drop, fizz and sip format makes MetaFizz+ straightforward to incorporate into your everyday routine."

      },

      home: {

        title:
          "An easy daily ritual",

        text:
          "The simple drop, fizz and sip format makes MetaFizz+ straightforward to incorporate into your everyday routine."

      }

    },


    /*
    ----------------------------------------------------------
    MOTIVATION RESULT MAPPING
    ----------------------------------------------------------
    */

    motivationMapping: {

      ingredients: {

        title:
          "A multi-ingredient formula",

        text:
          "Each tablet contains 500 mg ACV, 300 mg Moringa, 100 mg Pomegranate, Vitamin B6 and Vitamin B12."

      },

      benefits: {

        title:
          "Clear product purpose",

        text:
          "MetaFizz+ brings ACV, Moringa, Pomegranate and Vitamins B6 and B12 together for its approved wellness-support positioning."

      },

      taste: {

        title:
          "Refreshing pomegranate experience",

        text:
          "MetaFizz+ transforms into a refreshing pomegranate-flavoured drink, making the daily routine more enjoyable."

      },

      convenience: {

        title:
          "Convenient preparation",

        text:
          "One tablet into 200 ml of cold water, dissolve completely, and drink 30 minutes before a meal."

      },

      consistency: {

        title:
          "Built around a simple ritual",

        text:
          "A clear one-tablet daily routine can make it easier to build MetaFizz+ into a consistent wellness habit."

      }

    },


    /*
    ----------------------------------------------------------
    ROUTINE PREFERENCE MAPPING
    ----------------------------------------------------------
    */

    preferenceMapping: {

      simple: {

        title:
          "Keep it simple",

        text:
          "MetaFizz+ is designed around a straightforward one-tablet daily ritual."

      },

      morning: {

        title:
          "Easy to build into your routine",

        text:
          "The simple effervescent format can be incorporated into a morning wellness routine."

      },

      refreshing: {

        title:
          "A refreshing daily experience",

        text:
          "The pomegranate flavour gives the effervescent routine a refreshing drink experience."

      },

      structured: {

        title:
          "A clear daily ritual",

        text:
          "The one-tablet format and defined preparation steps make the routine straightforward to follow."

      },

      figuring_out: {

        title:
          "Start with a simple routine",

        text:
          "MetaFizz+ offers a straightforward one-tablet effervescent format for building a daily wellness ritual."

      }

    },


    /*
    ----------------------------------------------------------
    FAQ
    ----------------------------------------------------------
    */

    faqs: [

      {

        question:
          "How does MetaFizz+ taste?",

        answer:
          "MetaFizz+ has a refreshing pomegranate flavour designed to make an ACV-based daily routine more enjoyable than the traditional vinegar-shot experience."

      },

      {

        question:
          "How do I prepare it?",

        answer:
          "Drop one tablet into 200 ml of cold water and allow it to dissolve completely before drinking."

      },

      {

        question:
          "How often should I take it?",

        answer:
          "The approved routine is one tablet per day, consumed 30 minutes before a meal."

      },

      {

        question:
          "What are the key ingredients?",

        answer:
          "Each tablet contains 500 mg Apple Cider Vinegar, 300 mg Moringa, 100 mg Pomegranate, Vitamin B6 and Vitamin B12."

      }

    ],


    /*
    ----------------------------------------------------------
    FINAL CTA
    ----------------------------------------------------------
    */

    cta: {

      title:
        "Ready to add it to your routine?",

      text:
        "If MetaFizz+ feels like a good fit for what you're looking for, you can add it to your routine below.",

      buttonText:
        "Add MetaFizz+ to My Routine",

      note:
        "You'll continue through Varikaa's existing checkout experience."

    }

    },

  /*
  ==========================================================
  PRODUCT 02 — MORINGA
  ==========================================================
  */

  moringa: {

    /*
    ----------------------------------------------------------
    BASIC PRODUCT INFORMATION
    ----------------------------------------------------------
    */

    id: "moringa",

    name: "Varikaa Natural Moringa Leaf Powder",

    handle: "natural-moringa-powder",

    productUrl:
      "/products/natural-moringa-powder",


    /*
    ----------------------------------------------------------
    HERO EXPERIENCE
    ----------------------------------------------------------
    */

    hero: {

      heroImage:
        "https://cdn.shopify.com/s/files/1/0704/9186/5167/files/IMG-4297.png?v=1788584564",

      splashImage:
        "https://cdn.shopify.com/s/files/1/0704/9186/5167/files/FA8506EB-BBB1-40D4-8208-F6A7D8760841.png?v=1788631584",

      triggerAfterScrollPercent: 10,

      position: "right-center",

      entranceAnimation: "drop",

      invitationTitle:
        "Is Moringa right for your routine?",

      invitationAction:
        "Let’s find out →"

    },


    /*
    ----------------------------------------------------------
    PRODUCT INFORMATION
    ----------------------------------------------------------
    */

    formula: {

      ingredient: {
        amount: "100%",
        displayName:
          "Pure Moringa Leaf Powder (Moringa oleifera)"
      },

      calcium: {
        amount: "Naturally present",
        displayName: "Calcium"
      },

      iron: {
        amount: "Naturally present",
        displayName: "Iron"
      },

      dietaryFiber: {
        amount: "Naturally present",
        displayName: "Dietary Fibre"
      },

      vitamins: {
        amount: "A & C",
        displayName: "Vitamins A & C"
      },

      aminoAcids: {
        amount: "9",
        displayName:
          "Essential Amino Acids"
      },

      polyphenols: {
        amount: "Naturally present",
        displayName:
          "Polyphenols / Antioxidant Compounds"
      }

    },


    /*
    ----------------------------------------------------------
    PRODUCT FORMAT
    ----------------------------------------------------------
    */

    format: {

      type: "Moringa leaf powder",

      flavour:
        "Mild, earthy taste, closest to green tea",

      netWeight: "200g",

      processing:
        "Shade-dried and stone-milled",

      ingredientCount:
        "Single ingredient"

    },


    /*
    ----------------------------------------------------------
    APPROVED PRODUCT ATTRIBUTES
    ----------------------------------------------------------
    */

    attributes: {

      vegan: true,

      glutenFree: true,

      whoGmpFacility: true,

      fssaiApproved: true,

      noAddedSugar: true,

      noPreservatives: true

    },


    /*
    ----------------------------------------------------------
    APPROVED BENEFIT PILLARS
    ----------------------------------------------------------
    */

    benefits: {

      nutrition: {

        title:
          "Everyday plant-based nutrition",

        ingredient:
          "Pure Moringa Leaf Powder",

        text:
          "Moringa is a nutrient-rich plant food that provides naturally occurring plant-based nutrients, including calcium, iron and dietary fibre."

      },


      energy: {

        title:
          "Nutritional support for everyday energy",

        ingredient:
          "Iron + plant-based nutrients",

        text:
          "Moringa provides naturally occurring iron and other plant-based nutrients that contribute to its nutrient-rich everyday wellness profile."

      },


      immunity: {

        title:
          "Nutritional support for everyday immunity",

        ingredient:
          "Vitamins A & C",

        text:
          "Moringa provides Vitamins A and C, which contribute to normal immune-system function."

      },


      fibre: {

        title:
          "A natural source of dietary fibre",

        ingredient:
          "Dietary Fibre",

        text:
          "Moringa naturally contains dietary fibre, making it an easy way to add more fibre to a whole-food wellness routine."

      }

    },


    /*
    ----------------------------------------------------------
    USAGE
    ----------------------------------------------------------
    */

    usage: {

      frequency:
        "1 scoop (3–5g) once daily",

      preparation:
        "Mix 1 scoop (3–5g) into water, herbal juice, shakes, smoothies or suitable foods.",

      timing:
        "Preferably in the morning. During the first week, start with ½ tsp and build up.",

      hotWaterWarning:
        "",

      storage:
        "Store in a cool, dry place away from direct sunlight and keep the container tightly closed."

    },


    /*
    ----------------------------------------------------------
    QUESTIONS
    ----------------------------------------------------------
    */

    questions: [

      {

        id: "q1",

        number: 1,

        title:
          "What are you looking to add to your everyday wellness routine?",

        options: [

          {
            value: "nutrition",
            label:
              "More plant-based nutrition",
              icon: "🌿"
          },

          {
            value: "energy",
            label:
              "Everyday energy & nutrient support"
          },

          {
            value: "immunity",
            label:
              "Nutritional support for everyday immunity",
              icon: "🛡️"
          },

          {
            value: "fibre",
            label:
              "More fibre and whole-food goodness",
              icon: "🌾"
          },

          {
            value: "combination",
            label:
              "A simple combination of these"
          }

        ]

      },


      {

        id: "q2",

        number: 2,

        title:
          "What does your typical day look like?",

        options: [

          {
            value: "busy",
            label:
              "Busy & always on the go"
          },

          {
            value: "desk",
            label:
              "Mostly work / desk-based"
          },

          {
            value: "active",
            label:
              "Active & fitness-focused"
          },

          {
            value: "home",
            label:
              "Mostly home-based"
          },

          {
            value: "changing",
            label:
              "My routine changes day to day"
          }

        ]

      },


      {

        id: "q3",

        number: 3,

        title:
          "What matters most to you when choosing a daily wellness food?",

        options: [

          {
            value: "ingredients",
            label:
              "Clean, simple ingredients"
          },

          {
            value: "nutrition",
            label:
              "Nutritional value",
              icon: "🥗" 
          },

          {
            value: "benefits",
            label:
              "Everyday wellness benefits"
          },

          {
            value: "convenience",
            label:
              "Easy to add to food or drinks"
          },

          {
            value: "consistency",
            label:
              "Something I can actually stay consistent with"
          }

        ]

      },


      {

        id: "q4",

        number: 4,

        title:
          "How would you most enjoy adding Moringa to your routine?",

        options: [

          {
            value: "morning",
            label:
              "Morning water ritual"
          },

          {
            value: "smoothies",
            label:
              "Smoothies or shakes",
              icon: "🥤"
          },

          {
            value: "buttermilk",
            label:
              "Buttermilk / curd",
              icon: "🥛"
          },

          {
            value: "meals",
            label:
              "Meals like dal, soups or chutney",
              icon: "🍲"
          },

          {
            value: "figuring_out",
            label:
              "I’m still figuring it out"
          }

        ]

      }

    ],


    /*
    ----------------------------------------------------------
    QUESTION SIGNAL PRIORITY
    ----------------------------------------------------------

    Q1 = Primary wellness signal
    Q2 = Routine compatibility
    Q3 = Buying motivation
    Q4 = Routine framing

    These are personalization signals only.
    They are NOT medical diagnosis.
    ----------------------------------------------------------
    */

    recommendationSignals: {

      primary: "q1",

      secondary: "q2",

      motivation: "q3",

      routinePreference: "q4"

    },


    /*
    ----------------------------------------------------------
    RESULT INTRODUCTION
    ----------------------------------------------------------
    */

    result: {

      title:
        "Here’s how Moringa may fit your routine.",

      defaultIntro:
        "Varikaa Natural Moringa Leaf Powder is a nutrient-rich, single-ingredient food made from pure Moringa oleifera leaf powder for everyday wellness."

    },


    /*
    ----------------------------------------------------------
    RESULT MAPPING
    ----------------------------------------------------------
    */

    resultMapping: {

      nutrition: {

        intro:
          "You're looking to add more plant-based nutrition to your routine. Moringa may fit that goal as a nutrient-rich, single-ingredient plant food.",

        focusTitle:
          "Plant-based nutrition",

        focusText:
          "Pure Moringa Leaf Powder provides naturally occurring plant-based nutrients, including calcium, iron and dietary fibre."

      },


      energy: {

        intro:
          "You're looking for everyday energy and nutrient support. Moringa may fit that goal through its naturally occurring iron and nutrient-rich profile.",

        focusTitle:
          "Everyday energy & nutrient support",

        focusText:
          "Moringa naturally contains iron and other plant-based nutrients that contribute to its nutrient-rich everyday wellness profile."

      },


      immunity: {

        intro:
          "You're looking for nutritional support for everyday immunity. Moringa may fit that goal as a source of Vitamins A and C.",

        focusTitle:
          "Everyday immune nutritional support",

        focusText:
          "Moringa provides Vitamins A and C, which contribute to normal immune-system function."

      },


      fibre: {

        intro:
          "You're looking to add more fibre and whole-food goodness to your routine. Moringa may fit that goal as a natural source of dietary fibre.",

        focusTitle:
          "Dietary fibre support",

        focusText:
          "Moringa naturally contains dietary fibre, making it an easy way to add more fibre to your everyday food routine."

      },


      combination: {

        intro:
          "You're looking for a combination of everyday wellness benefits. Moringa may fit that broader goal through its nutrient-rich, single-ingredient profile.",

        focusTitle:
          "A broader everyday wellness routine",

        focusText:
          "Pure Moringa Leaf Powder provides naturally occurring plant-based nutrients including calcium, iron and dietary fibre, along with Vitamins A and C."

      }

    },


    /*
    ----------------------------------------------------------
    ROUTINE RESULT MAPPING
    ----------------------------------------------------------
    */

    routineMapping: {

      busy: {

        title:
          "Easy to add to a busy routine",

        text:
          "Moringa can be mixed into a drink or added to suitable foods, making it practical to incorporate into a changing day."

      },


      changing: {

        title:
          "Flexible everyday use",

        text:
          "Moringa can be mixed into water, herbal juice, shakes, smoothies or suitable foods, giving you several ways to build it into your routine."

      },


      active: {

        title:
          "Fits an active routine",

        text:
          "Moringa can be added to smoothies or shakes as part of a simple everyday nutrition routine."

      },


      desk: {

        title:
          "A simple desk-day addition",

        text:
          "Moringa can be mixed into a drink or suitable food, making it straightforward to include during a work-focused day."

      },


      home: {

        title:
          "Easy to build into home routines",

        text:
          "Moringa can be incorporated into everyday drinks or meals, giving you a simple food-based wellness option at home."

      }

    },


    /*
    ----------------------------------------------------------
    MOTIVATION RESULT MAPPING
    ----------------------------------------------------------
    */

    motivationMapping: {

      ingredients: {

        title:
          "A simple single-ingredient choice",

        text:
          "Varikaa Moringa is made with pure Moringa Leaf Powder (Moringa oleifera) as its single ingredient."

      },


      nutrition: {

        title:
          "Nutrient-rich profile",

        text:
          "Moringa naturally provides plant-based nutrients including calcium, iron and dietary fibre, along with Vitamins A and C."

      },


      benefits: {

        title:
          "Clear everyday wellness purpose",

        text:
          "Moringa is positioned as a nutrient-rich superfood for everyday wellness, with a naturally occurring nutritional profile."

      },


      convenience: {

        title:
          "Easy to add to food or drinks",

        text:
          "Your daily Moringa serving can be mixed into water, herbal juice, shakes or smoothies, or incorporated into suitable foods."

      },


      consistency: {

        title:
          "Simple to make part of a routine",

        text:
          "A defined daily serving and multiple ways to consume it make Moringa straightforward to incorporate into an everyday routine."

      }

    },


    /*
    ----------------------------------------------------------
    ROUTINE PREFERENCE MAPPING
    ----------------------------------------------------------
    */

    preferenceMapping: {

      morning: {

        title:
          "A natural morning ritual",

        text:
          "Your preferred routine can be built around a morning Moringa serving, preferably taken at the start of your day."

      },


      smoothies: {

        title:
          "Made for smoothies & shakes",

        text:
          "Moringa can be mixed into smoothies or shakes, making it easy to pair with a routine you already enjoy."

      },


      buttermilk: {

        title:
          "Easy to pair with everyday foods",

        text:
          "Moringa can be incorporated into buttermilk or curd as one practical way to add it to your routine."

      },


      meals: {

        title:
          "Fits naturally into meals",

        text:
          "Moringa can be incorporated into suitable meals such as dal, soups or chutney."

      },


      figuring_out: {

        title:
          "Start with what feels easiest",

        text:
          "Choose a simple way to add your daily Moringa serving, such as mixing it into water, a smoothie or suitable food."

      }

    },


    /*
    ----------------------------------------------------------
    FAQ
    ----------------------------------------------------------
    */

    faqs: [

      {

        question:
          "What is Varikaa Moringa made from?",

        answer:
          "It is made from pure Moringa Leaf Powder (Moringa oleifera)."

      },


      {

        question:
          "How much Moringa should I take?",

        answer:
          "The current recommended routine is 1 scoop (3–5g) once daily, preferably in the morning. During the first week, start with ½ tsp and build up."

      },


      {

        question:
          "How can I add Moringa to my routine?",

        answer:
          "Mix it into water, herbal juice, shakes or smoothies, or incorporate it into suitable foods."

      },


      {

        question:
          "How does Moringa taste?",

        answer:
          "Moringa has a mild, earthy taste that is closest to green tea."

      },


      {

        question:
          "What nutrients does Moringa naturally provide?",

        answer:
          "Moringa is naturally rich in plant-based nutrients, including calcium, iron and dietary fibre. It also provides Vitamins A and C, nine essential amino acids and naturally occurring polyphenols."

      },


      {

        question:
          "How should I store Moringa powder?",

        answer:
          "Store it in a cool, dry place away from direct sunlight and keep the container tightly closed."

      }

    ],


    /*
    ----------------------------------------------------------
    FINAL CTA
    ----------------------------------------------------------
    */

    cta: {

      title:
        "Ready to add it to your routine?",

      text:
        "If Moringa feels like a good fit for what you're looking for, you can add it to your routine below.",

      buttonText:
        "Add Moringa to My Routine",

      note:
        "You'll continue through Varikaa's existing checkout experience."

    }

  },
    isabgol: {
    id: "isabgol",
    name: "Psyllium Husk (Isabgol) Powder",
    handle: "psyllium-husk-powder-100-g",
    productUrl: "/products/psyllium-husk-powder-100-g",

    hero: {
      heroImage: "https://cdn.shopify.com/s/files/1/0704/9186/5167/files/IMG-4298.png?v=1788584564",
      splashImage: "https://cdn.shopify.com/s/files/1/0704/9186/5167/files/0324BE0F-B738-45DB-930F-E170A1A88DCA.png?v=1788757425",
      triggerAfterScrollPercent: 10,
      position: "right-center",
      entranceAnimation: "drop",
        heroScale: 1.35,
        splashScale: 0.72,
      invitationTitle: "Is Isabgol right for your routine?",
      invitationAction: "Let’s find out →"
    },

    productInfo: {
      ingredient: "Psyllium Husk (Plantago ovata seed husk)",
      netWeight: "100g",
      positioning: "Premium Daily Fibre Supplement"
    },

    benefits: {
      regularity: {
        title: "Daily digestive regularity",
        text: "Psyllium Husk is a plant-based source of dietary fibre that can support a simple daily digestive-wellness routine."
      },
      digestiveComfort: {
        title: "Digestive comfort",
        text: "Its fibre-rich format makes Isabgol a straightforward addition to an everyday routine focused on digestive comfort."
      },
      gutWellness: {
        title: "Everyday gut wellness",
        text: "Isabgol provides plant-based dietary fibre for an easy daily approach to digestive and gut wellness."
      },
      fibre: {
        title: "A simple way to add fibre",
        text: "Psyllium Husk offers a convenient plant-based way to add dietary fibre to your everyday routine."
      },
      fullness: {
        title: "Helps support feelings of fullness",
        text: "The high-fibre nature of psyllium may help increase feelings of fullness as part of a balanced diet and active lifestyle."
      }
    },

    usage: {
      frequency: "1–2 teaspoons, up to 5g",
      preparation: "Mix 1–2 teaspoons (up to 5g) into 200 ml of water, stir well and consume immediately. Follow with an additional glass of water.",
      timing: "Best consumed after meals.",
      hotWaterWarning: "Always consume with sufficient water. Psyllium absorbs water and expands."
    },

    attributes: [
      "Clean-label formula",
      "Naturally sourced",
      "Plant-based",
      "No artificial colours",
      "No preservatives",
      "No added sugar",
      "No harmful additives"
    ],

    certifications: [
      "FSSAI Approved",
      "Lab Tested"
    ],

    questions: [
      {
        id: "q1",
        number: 1,
        title: "What are you looking to add to your everyday wellness routine?",
        options: [
          { value: "regularity", label: "Better daily regularity", icon: "🌿" },
          { value: "digestive_comfort", label: "Digestive comfort & gut wellness", icon: "🍃" },
          { value: "more_fibre", label: "More fibre in my diet", icon: "🌾" },
          { value: "fullness", label: "Feeling fuller between meals", icon: "🥣" },
          { value: "combination", label: "A simple combination of these", icon: "✨" }
        ]
      },
      {
        id: "q2",
        number: 2,
        title: "What does your typical day look like?",
        options: [
          { value: "busy", label: "Busy & always on the go", icon: "🏃" },
          { value: "desk", label: "Mostly work / desk-based", icon: "💻" },
          { value: "active", label: "Active & fitness-focused", icon: "🏋️" },
          { value: "home", label: "Mostly home-based", icon: "🏠" },
          { value: "changing", label: "My routine changes day to day", icon: "🔄" }
        ]
      },
      {
        id: "q3",
        number: 3,
        title: "What matters most to you when choosing a daily fibre supplement?",
        options: [
          { value: "clean_ingredients", label: "Clean, simple ingredients", icon: "🌿" },
          { value: "plant_fibre", label: "Natural plant-based fibre", icon: "🌾" },
          { value: "digestive_wellness", label: "Digestive wellness support", icon: "🍃" },
          { value: "easy_routine", label: "Easy to add to my routine", icon: "⏱️"  },
          { value: "consistency", label: "Something I can actually stay consistent with", icon: "🔁" }
        ]
      },
      {
        id: "q4",
        number: 4,
        title: "When would you most naturally fit Isabgol into your day?",
        options: [
          { value: "after_meals", label: "After my meals", icon: "🍽️" },
          { value: "morning", label: "As part of my morning routine", icon: "🌅" },
          { value: "bedtime", label: "Before bedtime", icon: "🌙" },
          { value: "drink", label: "With a drink like water or juice", icon: "🥤" },
          { value: "figuring_out", label: "I’m still figuring it out", icon: "🤔" }
        ]
      }
    ],

    resultMapping: {
      regularity: {
        intro: "If daily regularity is what you’re looking for, Isabgol may fit naturally into your routine as a simple plant-based source of dietary fibre.",
        focusTitle: "Daily digestive regularity",
        focusText: "Psyllium Husk provides plant-based dietary fibre that can support an everyday routine focused on regularity and digestive wellness."
      },
      digestive_comfort: {
        intro: "If digestive comfort and gut wellness are priorities for you, Isabgol may be a simple fibre-focused addition to your routine.",
        focusTitle: "Digestive comfort",
        focusText: "Isabgol is a plant-based source of dietary fibre designed to support a simple daily digestive-wellness routine."
      },
      more_fibre: {
        intro: "If you want an easy way to add more fibre to your day, Isabgol may fit neatly into your everyday routine.",
        focusTitle: "A simple way to add fibre",
        focusText: "Psyllium Husk provides dietary fibre in a straightforward plant-based format that can be added to a daily routine."
      },
      fullness: {
        intro: "If feeling fuller between meals matters to you, Isabgol may fit as a fibre-focused addition to a balanced daily routine.",
        focusTitle: "Fibre & fullness",
        focusText: "The high-fibre nature of psyllium may help increase feelings of fullness as part of a balanced diet and active lifestyle."
      },
      combination: {
        intro: "If you’re looking for a simple combination of digestive wellness and more fibre, Isabgol may fit your everyday routine.",
        focusTitle: "Simple daily fibre support",
        focusText: "Isabgol provides plant-based dietary fibre for an easy daily approach to digestive wellness and regularity."
      }
    },

    routineMapping: {
      busy: { title: "Easy to keep in a busy routine", text: "The preparation is straightforward: mix the recommended amount with water, stir well and consume immediately." },
      desk: { title: "A simple desk-day addition", text: "A glass of water and a few simple preparation steps make Isabgol easy to build into a structured daily routine." },
      active: { title: "Fits an active routine", text: "Isabgol can be incorporated into an everyday fibre routine alongside a balanced diet and active lifestyle." },
      home: { title: "Easy to build into a home routine", text: "Its simple water-based preparation makes it straightforward to incorporate into a regular daily habit." },
      changing: { title: "Flexible enough for changing days", text: "The simple preparation format can be fitted around the part of your day that works most naturally for you." }
    },

    motivationMapping: {
      clean_ingredients: { title: "Clean-label formula", text: "Isabgol is positioned around a clean-label formula with naturally sourced, plant-based psyllium husk." },
      plant_fibre: { title: "Plant-based fibre", text: "The product uses Psyllium Husk (Plantago ovata seed husk) as a plant-based source of dietary fibre." },
      digestive_wellness: { title: "Focused on digestive wellness", text: "Isabgol is designed around everyday digestive wellness, regularity and a simple fibre-focused routine." },
      easy_routine: { title: "Simple preparation", text: "Mix the recommended amount with water, stir well and consume immediately for a straightforward daily routine." },
      consistency: { title: "Built for consistency", text: "A simple, repeatable preparation can make it easier to build a daily fibre habit into your routine." }
    },

    preferenceMapping: {
      after_meals: { title: "After-meal routine", text: "Your preferred timing aligns with the approved product guidance: Isabgol is best consumed after meals." },
      morning: { title: "Morning routine", text: "If mornings work best for you, Isabgol can be planned as part of your broader daily routine while following the recommended preparation and hydration guidance." },
      bedtime: { title: "Evening routine", text: "You can plan your fibre routine around the time that is easiest to maintain, while following the recommended preparation and hydration guidance." },
      drink: { title: "Easy drink-based routine", text: "Isabgol is prepared by mixing the recommended amount with water and consuming it immediately." },
      figuring_out: { title: "Start with a simple routine", text: "Begin with the approved preparation and hydration guidance, then build the routine around the time you can maintain consistently." }
    },

    result: {
      title: "Here’s how Isabgol may fit your routine.",
      defaultIntro: "Isabgol may be a simple way to add plant-based dietary fibre to an everyday digestive-wellness routine."
    },

    faqs: [
      {
        question: "What is Isabgol?",
        answer: "Isabgol is Psyllium Husk (Plantago ovata seed husk), a plant-based source of dietary fibre."
      },
      {
        question: "How should I consume it?",
        answer: "Mix 1–2 teaspoons, up to 5g, into 200 ml of water. Stir well and consume immediately, then follow with an additional glass of water."
      },
      {
        question: "Why is hydration important?",
        answer: "Psyllium absorbs water and expands, so it should be consumed with sufficient water and followed by adequate hydration throughout the day."
      },
      {
        question: "When is the recommended time to take it?",
        answer: "The approved routine for this experience is to consume it after meals."
      },
      {
        question: "Does it contain added sugar?",
        answer: "The approved product positioning states no added sugar."
      },
      {
        question: "What are the product’s quality attributes?",
        answer: "The approved attributes are clean-label formula, naturally sourced, plant-based, no artificial colours, no preservatives, no added sugar and no harmful additives. The approved quality credentials are FSSAI Approved and Lab Tested."
      }
    ],

    cta: {
  title: "Ready to add Isabgol to your routine?",

  text:
    "If Isabgol feels like a good fit for what you’re looking for, you can add it through the existing product-page purchase flow.",

  buttonText:
    "Add Isabgol to My Routine",

  variantId:
    "45280116441167",

  note:
    "You’ll continue through Varikaa's existing checkout experience."
}
  },
};

/*
============================================================
END PRODUCT CONTROL PANEL
============================================================
*/
window.VARIKAA_AI_PRODUCTS = VARIKAA_AI_PRODUCTS;